import { FETCH_PRODUCTS_SUCCESS } from './../const';

export default (json) => {
  return {type: FETCH_PRODUCTS_SUCCESS, json}
};
